// extracted by mini-css-extract-plugin
export default {"small":"Loader_small__866Iz","medium":"Loader_medium__tLfOI","large":"Loader_large__rRupB"};